var _a;
import getConfig from 'next/config';
const domain = (_a = getConfig()) === null || _a === void 0 ? void 0 : _a.publicRuntimeConfig.domain;
export const CCPA_OPT_OUT = 'OptedOutOfSalePersonalInformationOnFirework';
export const cookieConsentMaxDays = () => {
    const maxDays = 365;
    const expireDate = new Date();
    expireDate.setDate(expireDate.getDate() + maxDays);
    return expireDate;
};
function shouldSetDomain() {
    return !!domain && !!window.location.origin.match(domain);
}
// Set the cookie domain if on fw.tv or username.fw.tv so it can be shared
// between subdomains
function cookieDomain() {
    if (shouldSetDomain()) {
        return `;domain=.${domain}`;
    }
    return '';
}
const Cookies = {
    get: (cname) => {
        const name = `${cname}=`;
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return null;
    },
    set: (name, value, expirationDate) => {
        if (expirationDate) {
            document.cookie = `${name}=${value};expires=${expirationDate.toUTCString()};path=/${cookieDomain()}`;
        }
        else {
            document.cookie = `${name}=${value};path=/${cookieDomain()}`;
        }
    },
    remove: (name) => {
        document.cookie = `${name}=;max-age=0;path=/${cookieDomain()}`;
    },
};
export default Cookies;
